module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer037"
    }
  }, [_c('p', {
    staticClass: "Graphic",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/binosaur.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Prelim-head-2"
  }, [_vm._v("ABOUT THE AUTHORS")]), _vm._v(" "), _c('p', {
    staticClass: "Prelim-main"
  }, [_vm._v("David and Stephen are identical twins. They were both children’s doctors, but now they are so old that they have been reclassified as dinosaurs. David is a Daveosaurus, Stephen is a Steveodactyl. ")]), _vm._v(" "), _c('p', {
    staticClass: "Prelim-main"
  }, [_vm._v("Their book is for all ages. They want dinosaurs to feel better about human beings.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-445d0017","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781035845781_EPUB.vue
// module id = 57
// module chunks = 0